import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserScopesService } from '../services/user-scopes.service';

export const hasScopesResolver: (
  requiredScopes: string[],
) => ResolveFn<boolean> = (requiredScopes) => () => {
  return inject(UserScopesService)
    .hasScopes(requiredScopes)
    .pipe(
      map((hasScopes) => {
        return hasScopes;
      }),
      catchError(() => of(false)),
    );
};
